import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { Heart } from 'lucide-react'
import SectionHeading from '@/components/landing/section-heading'
import { invitation } from '@/constants/invitation'

const MessageSection: FC = (): ReactNode => {
    const { honoree, message } = invitation

    return (
        <section id='le-mot' aria-labelledby='le-mot-titre' className='relative overflow-hidden py-24 sm:py-32'>
            <div className='mx-auto grid max-w-6xl items-center gap-20 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20'>
                <div className='relative mx-auto w-full max-w-md lg:max-w-none'>
                    <div className='relative aspect-[4/5] -rotate-2 overflow-hidden rounded-[2rem] shadow-2xl shadow-foreground/10 ring-1 ring-foreground/5'>
                        <Image
                            src='/images/toast.jpg'
                            alt='Des amis trinquent avec des verres de champagne rosé'
                            fill
                            sizes='(min-width: 1024px) 34rem, (min-width: 640px) 28rem, 90vw'
                            className='object-cover'
                        />
                    </div>

                    <figure className='absolute -right-1 -bottom-12 w-40 rotate-6 rounded-2xl bg-card p-2.5 pb-3 shadow-xl ring-1 ring-foreground/5 sm:-right-8 sm:w-52'>
                        <div className='relative aspect-square overflow-hidden rounded-xl'>
                            <Image
                                src='/images/gateau.jpg'
                                alt='Une carte d’anniversaire illustrée d’un gâteau et de sa bougie'
                                fill
                                sizes='13rem'
                                className='object-cover'
                            />
                        </div>

                        <figcaption className='mt-2 text-center font-heading text-base italic'>
                            Faites un vœu !
                        </figcaption>
                    </figure>

                    <span
                        aria-hidden='true'
                        className='absolute -top-4 left-10 h-8 w-28 -rotate-6 rounded-sm bg-festive-saffron/70 shadow-sm'
                    />
                </div>

                <div>
                    <SectionHeading id='le-mot-titre' eyebrow={`Le mot de ${honoree}`} title={message.title} />

                    <div className='mt-7 space-y-5 text-lg leading-relaxed text-muted-foreground text-pretty'>
                        {message.paragraphs.map(paragraph => (
                            <p key={paragraph}>
                                {paragraph}
                            </p>
                        ))}
                    </div>

                    <p className='mt-10 flex items-center gap-3 font-heading text-4xl text-primary italic'>
                        {message.signature}
                        <Heart className='size-6 fill-current' aria-hidden='true' />
                    </p>
                </div>
            </div>
        </section>
    )
}

export default MessageSection
